module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', [_c('h3', [_vm._v("Survey details")]), _vm._v(" "), _c('el-form', {
    ref: "surveyForm",
    attrs: {
      "model": _vm.surveyForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "300px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.surveyForm.title),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "title", $$v)
      },
      expression: "surveyForm.title"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("What would you like this survey to be called?")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.surveyForm.description),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "description", $$v)
      },
      expression: "surveyForm.description"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("A brief summary of what our survey is about.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Date range",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.surveyForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "dateRange", $$v)
      },
      expression: "surveyForm.dateRange"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Period of time in which we'll be running this survey.")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Survey Type",
      "prop": "surveyType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.surveyForm.surveyType),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "surveyType", $$v)
      },
      expression: "surveyForm.surveyType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "QUALITATIVE"
    }
  }, [_vm._v("Qualitative Survey")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "MUSIC"
    }
  }, [_vm._v("Music Survey")])], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Completion")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "On survey completed"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.surveyForm.successAutoRedirect),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "successAutoRedirect", $$v)
      },
      expression: "surveyForm.successAutoRedirect"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("Display a message")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Redirect to a webpage")])], 1), _vm._v(" "), _c('help-text', [_vm._v("What should we do once a listener has completed this survey?")])], 1), _vm._v(" "), (!_vm.surveyForm.successAutoRedirect) ? _c('el-form-item', {
    attrs: {
      "label": "Success message",
      "prop": "successText"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.surveyForm.successText),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "successText", $$v)
      },
      expression: "surveyForm.successText"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Once the listener has completed their survey, we'll display this message.")])], 1) : _vm._e(), _vm._v(" "), (_vm.surveyForm.successAutoRedirect) ? _c('el-form-item', {
    attrs: {
      "label": "Redirect URL",
      "prop": "successRedirect"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.successRedirect),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "successRedirect", $$v)
      },
      expression: "surveyForm.successRedirect"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Once the listener has completed their survey, we'll take them to this webpage.")])], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h3', [_vm._v("Privacy")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Privacy Policy URL",
      "prop": "privacyPolicy"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "https://"
    },
    model: {
      value: (_vm.surveyForm.privacyPolicy),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "privacyPolicy", $$v)
      },
      expression: "surveyForm.privacyPolicy"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("Should we include a link to our privacy policy?")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Collect non voluntary identifiers",
      "prop": "collectNonVoluntaryIdentifiers"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.surveyForm.collectNonVoluntaryIdentifiers),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "collectNonVoluntaryIdentifiers", $$v)
      },
      expression: "surveyForm.collectNonVoluntaryIdentifiers"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("\n        Should we capture information from the listener's browser, that could uniquely identify\n        the listener, such as ip address and browser / device fingerprints? (Please make mention\n        of this within your privacy policy should you choose this option)\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Show progress bar",
      "prop": "showProgressBar"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.surveyForm.showProgressBar),
      callback: function($$v) {
        _vm.$set(_vm.surveyForm, "showProgressBar", $$v)
      },
      expression: "surveyForm.showProgressBar"
    }
  }), _vm._v(" "), _c('help-text', [_vm._v("\n        Turning this on will show a progress Bar at the bottom of each survey page.\n      ")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.surveySaving
    },
    on: {
      "click": _vm.handleSaveSurvey
    }
  }, [_vm._v("Save Survey")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.surveySaving
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-862ea7ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/tabs/SetupTab.vue
// module id = 3362
// module chunks = 3